import type { ReactNode } from "react"
import styles from "./FieldHint.module.css"

/**
 * How to answer a field, under its label. The control names it in
 * `aria-describedby`, so it is read with the control rather than only seen.
 */
export function FieldHint({
  id,
  children,
}: {
  id: string
  children: ReactNode
}) {
  return (
    <span id={id} className={styles.hint}>
      {children}
    </span>
  )
}
